import { useState } from 'react';
import type { FormEvent } from 'react';
import Card from './ui/Card';
import Button from './ui/Button';
import { InvestorLead } from '../types';

interface InvestorsProps {
    onAddLead: (lead: Omit<InvestorLead, 'id' | 'date'>) => void;
    t: {
        title: string;
        subtitle: string;
        listItem1: string;
        listItem2: string;
        listItem3: string;
        formTitle: string;
        formName: string;
        formEmail: string;
        formCompany: string;
        formMessage: string;
        formButton: string;
        thankYouTitle: string;
        thankYouText: string;
        thankYouButton: string;
    }
}

const Investors = ({ onAddLead, t }: InvestorsProps) => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const leadData = {
        name: formData.get('name') as string,
        email: formData.get('email') as string,
        company: formData.get('company') as string,
        message: formData.get('message') as string,
    };
    onAddLead(leadData);
    setSubmitted(true);
    e.currentTarget.reset();
  };

  return (
    <section id="investors" className="py-16 sm:py-24 bg-slate-900/70">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <h2 className="text-3xl sm:text-4xl font-black text-white">{t.title}</h2>
            <p className="mt-4 text-lg text-slate-300">
              {t.subtitle}
            </p>
            <ul className="mt-6 space-y-4 text-slate-300">
              <li className="flex items-start">
                <span className="text-blue-500 font-bold mr-2">✔</span>
                <span>{t.listItem1}</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 font-bold mr-2">✔</span>
                <span>{t.listItem2}</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 font-bold mr-2">✔</span>
                <span>{t.listItem3}</span>
              </li>
            </ul>
          </div>
          <Card>
            {submitted ? (
              <div className="text-center py-10">
                <h3 className="text-2xl font-bold text-green-400">{t.thankYouTitle}</h3>
                <p className="mt-2 text-slate-300">{t.thankYouText}</p>
                <Button variant="ghost" onClick={() => setSubmitted(false)} className="mt-4">{t.thankYouButton}</Button>
              </div>
            ) : (
              <form id="investor-lead-form" onSubmit={handleSubmit}>
                <h3 className="text-2xl font-bold text-white mb-6">{t.formTitle}</h3>
                <div className="space-y-4">
                  <input name="name" type="text" placeholder={t.formName} required className="w-full bg-slate-700 text-white p-3 rounded-lg border border-slate-600 focus:ring-2 focus:ring-blue-500 focus:outline-none"/>
                  <input name="email" type="email" placeholder={t.formEmail} required className="w-full bg-slate-700 text-white p-3 rounded-lg border border-slate-600 focus:ring-2 focus:ring-blue-500 focus:outline-none"/>
                  <input name="company" type="text" placeholder={t.formCompany} className="w-full bg-slate-700 text-white p-3 rounded-lg border border-slate-600 focus:ring-2 focus:ring-blue-500 focus:outline-none"/>
                  <textarea name="message" placeholder={t.formMessage} rows={3} className="w-full bg-slate-700 text-white p-3 rounded-lg border border-slate-600 focus:ring-2 focus:ring-blue-500 focus:outline-none"></textarea>
                </div>
                <Button id="btn-investor-lead-submit" type="submit" variant="accent" className="w-full mt-6">
                  {t.formButton}
                </Button>
              </form>
            )}
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Investors;